import React, { useEffect, useState, useRef } from 'react';
import { Menu, Row, Col, Card } from 'antd';

import GlossaryRelatedNodesResult, { RelatedNodeTypes } from './GlossaryRelatedNodesResult';
import { useEntityData } from '../shared/EntityContext';

export default function GlossayRelatedNode() {
    const { entityData } = useEntityData();
    const [selectedKey, setSelectedKey] = useState('');
    const [isAllLoaded, setIsAllLoaded] = useState(false);

    const menuOptionsArray = Object.keys(RelatedNodeTypes);

    const termsLoadingRef = useRef<Record<string, boolean>>({});

    useEffect(() => {
        if (menuOptionsArray && menuOptionsArray.length > 0 && selectedKey.length === 0) {
            setSelectedKey(menuOptionsArray[0]);
        }
    }, [menuOptionsArray, selectedKey]);

    const onMenuClick = ({ key }) => {
        setSelectedKey(key);
    };

    const trackTermLoading = (urn: string, trackLoading: boolean) => {
        termsLoadingRef.current[urn] = trackLoading;

        const allTermsLoaded = Object.values(termsLoadingRef.current).every((isLoading) => !isLoading);
        setIsAllLoaded(allTermsLoaded);
    };

    return (
        <Row>
            <Col xs={24} lg={4} className="pr-1">
                <Card style={{ height: '100%' }}>
                    <Menu
                        selectable={false}
                        mode="inline"
                        selectedKeys={[selectedKey]}
                        onClick={(key) => {
                            onMenuClick(key);
                        }}
                    >
                        {menuOptionsArray.map((option) => (
                            <Menu.Item data-testid={option} key={option} tabIndex={0}>
                                {RelatedNodeTypes[option]}
                            </Menu.Item>
                        ))}
                    </Menu>
                </Card>
            </Col>
            <Col xs={24} lg={20} className="f-pl-1-xs">
                {selectedKey && entityData && (
                    <GlossaryRelatedNodesResult
                        loading={!isAllLoaded}
                        trackTermLoading={trackTermLoading}
                        glossaryRelatedNodeType={RelatedNodeTypes[selectedKey]}
                        glossaryRelatedNodeResult={
                            entityData[selectedKey]?.relationships || entityData[selectedKey]?.nodes || []
                        }
                    />
                )}
            </Col>
        </Row>
    );
}
